<template>

    <div v-cloak class="container-fluid">

        <div v-if="isLoading">
            <div class="loading-div" v-if="isLoading">{{ isLoadingContent }}</div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col">
                    <h4 class="text-portal-soft-black pt-2">{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h5 class="text-portal-soft-black" v-once>
                        {{cmsContentBlocks['template.MskDirectCareCoordinator.Heading']}}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">
                <div class="col">

                    <div class="row d-none d-lg-block">
                        <div class="col">
                            <hr>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            {{cmsContentBlocks['template.MskDirectCareCoordinator.ToMessage']}}
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            {{cmsContentBlocks['generalOfficeCommunicationComponent.SubjectLabel']}}
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <select2-component key="subjectDropDown" title="Subject of message" v-error-message="{ errorModel: 'errorModel.subjectId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="referenceData.subjectDropDown" v-model="messageModel.subjectId" :placeholder="cmsContentBlocks['generalOfficeCommunicationComponent.SubjectLabel']">
                            </select2-component>
                            <span class="invalid-feedback is-invalid">{{ errorModel.subjectId | firstError }}</span>
                        </div>
                    </div>

                    <div class="row d-none d-lg-block">
                        <div class="col">
                            <hr>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                            <message-body-component v-model="messageModel.messageBody"
                                                    :error-model="errorModel"
                                                    :cms-content-blocks="cmsContentBlocks"
                                                    :non-english="nonEnglish"
                                                    :text-area-style-object="{ height: '200px !important' }"></message-body-component>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import { ReferenceDataHttpSvc } from '@SharedHttpServices/reference.data.httpservice';
    import { ResolveStaticContent } from '@SharedServices/localization.service';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue';

    export default {
        name: 'mskDirectCardCoordinatorTemplate',
        props: {
            subjectDropDown: { type: Array },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'message-body-component': composeMessageBody,
            'banner-component': mskBanner
        },
        data: function () {
            return {
                isLoading: true,

                referenceData: {
                    subjectDropDown: []
                },

                messageModel: {
                    subjectId: null,
                    messageBody: '',
                    attachmentGroupId: this.attachmentGroupId
                }
            }
        },
        computed: {
            isLoadingContent: function () {
                return ResolveStaticContent("Loading");
            }
        },
        created: function () {

            ReferenceDataHttpSvc.GetComposeMessageSubject('MskDirectCareCoordinator')
                .done(subjectResponse => {
                    this.referenceData.subjectDropDown = subjectResponse;
                    this.isLoading = false;
                });
        },
        mounted: function () {
            this.$emit('setMessageObject', this.messageModel);
        },
        watch: {
            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },
        }
    };
</script>

